import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StudentsForImpactService } from '../../../shared/services/students-for-impact.service';
import { UserService } from '../../../shared/services';
import { ToastyService } from 'ng2-toasty';
import { environment } from '../../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTable, DataTableTranslations, DataTableParams } from 'angular-datatables-all-versions';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';

import { CitizensForImpactListDataSource } from './citizens-for-impact-list.datasource';
import { IPaginationUsersImpact, IUsersImpact } from '../../students-for-impact/students-for-impact-list/ipagination-impact.model';
import { CitizensForImpactValidateComponent } from '../citizens-for-impact-validate/citizens-for-impact-validate.component';
import { User } from 'app/shared/models/user.model';
import { IUser } from 'app/shared/models/ipagination.model';

@Component({
  selector: 'app-citizens-for-impact-list',
  templateUrl: './citizens-for-impact-list.component.html',
  styleUrls: []
})
export class CitizensForImpactListComponent implements OnInit, AfterViewInit {

  @ViewChild('search_input', { static: true }) searchInputRef: ElementRef;
  @ViewChild('search_btn', { static: true }) searchBtnRef: ElementRef;
  @ViewChild(DataTable, { static: true }) citizensForImpactTable: DataTable;

  public site_url: string;
  users: IUsersImpact[] = [];
  userCount = 0;
  offset = 0;
  limits = [5, 10, 25, 50, 100];
  now = new Date();
  routeParams: DataTableParams;

  dataSource: CitizensForImpactListDataSource;

  translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Informations',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastyService: ToastyService,
    private modalService: NgbModal,
    private studentsForImpactService: StudentsForImpactService,
    private service: UserService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.dataSource = new CitizensForImpactListDataSource(studentsForImpactService);
    this.site_url = environment.base_url;
  }

  ngOnInit() {
    this.dataSource.load();
    this.dataSource.pagination.subscribe((data: IPaginationUsersImpact) => {
      if (data && data.hasOwnProperty('pagination')) {
        this.userCount = data.pagination.total;
        this.users = data.data;
      }
    });
  }

  ngAfterViewInit(): void {
    fromEvent(this.searchBtnRef.nativeElement, 'click').pipe(
      debounceTime(100),
      distinctUntilChanged(),
      tap(() => {
        this.changeDetector.detectChanges();
        this.citizensForImpactTable.offset = 1;
        this.loadUsersPage();
      })
    ).subscribe(() => {
      this.dataSource.pagination.subscribe(() => { this.changeDetector.detectChanges(); });
    });
  }

  reload(_params: DataTableParams) {
    this.routeParams = _params;
    this.loadUsersPage();
  }

  private loadUsersPage() {
    if (!this.routeParams) {
      this.routeParams = { offset: 0, limit: this.citizensForImpactTable.limit || 50 } as DataTableParams;
    }
    const offset = this.routeParams.offset / this.routeParams.limit;
    this.dataSource.load(this.searchInputRef.nativeElement.value, offset + 1, this.routeParams.limit, null);
  }

  onValidateDocuments(user: IUsersImpact) {
    const modalRef = this.modalService.open(CitizensForImpactValidateComponent, { size: 'lg' });
    modalRef.componentInstance.user = user;

    modalRef.result.then((result) => {
      if ('validation-success' === result) {
        this.loadUsersPage();
        this.toastyService.success({
          title: 'Succès',
          msg: 'Documents validés avec succès',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      }
    }, err => console.log('error', err));
  }

  isDocumentToValidate(currentUser: IUsersImpact): boolean {
    if (currentUser.self_employed && (currentUser.self_employed as any).id_card_status === 1) {
      return true;
    }
    if (currentUser.self_employed && currentUser.self_employed.status === 1) {
      return true;
    }
    return false;
  }

  isPdf(url: string): boolean {
    return url && url.toLowerCase().includes('.pdf');
  }

  onBanUser(user: IUser) {
    this.service.enableOrDesableUser(Object.assign(new User(), user)).subscribe(
      data => {
        this.loadUsersPage();
        const verb = data.is_active ? 'activ&eacute;e' : 'desactiv&eacute;e';
        this.toastyService.success({
          title: 'Success',
          msg: 'Utilisateur ' + verb,
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      },
      () => this.toastyService.error({
        title: 'Attention',
        msg: 'Une erreur s\'est produite, reessayer plus tard',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      })
    );
  }

  switchActivationCertificationImpact(user) {
    this.studentsForImpactService.onActivateOrDeactivateCertificationImpact(user.id).subscribe(
      data => {
        this.loadUsersPage();
        const verb = data.is_impact ? 'est certifié' : "n'est plus certifié";
        this.toastyService.success({
          title: 'Success',
          msg: 'Citizens for impact ' + verb,
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      },
      () => this.toastyService.error({
        title: 'Attention',
        msg: 'Une erreur s\'est produite, reessayer plus tard',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      })
    );
  }
}
